import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../constants/master-constants';
import { MatTableDataSource, } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { LineItemAvailabilityService } from './../../../services/seed/reports/line-item-availability.service';
import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { CommonService } from './../../../services/common/common.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-item-availability-detail',
  templateUrl: './item-availability-detail.component.html',
  styleUrls: ['./item-availability-detail.component.scss']
})
export class ItemAvailabilityDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  private subscription = new Array<Subscription>();
  curentDateTime: any;
  selectedAccount: any;
  accountNumber: number;
  public headerYear: any;
  public headerCompany = MasterConstants.US_COMPANYCODE;
  public companyName: any;
  public requestObject: any;

  productAvailabilityListDS: MatTableDataSource<any>;
  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;
  @ViewChild('availabilityTable', { read: MatSort }) itemSort: MatSort;
  itemList: string[];
  public selectedProductList: any = [];
  productAvailabilityList: any = [];
  paList: any = [];
  ignoreZeroQtyRecords = false;
  displayedResultColumns: string[] = ['itemDescription', 'seedAvailability', 'maturity', 'seedSize', 'packageSize', 'treatment', 'technology', 'marketingBrand', 'productLine'];

  constructor(public sliderModelService: SliderModelService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private reportService: LineItemAvailabilityService,
    private commonService: CommonService,
    public excelService: ExcelService) {
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    // Get company name using company code
    if (this.headerCompany) {
      this.subscription.push(this.commonService.getCompanyDetails().subscribe((results: any[]) => {
        if (results) {
          this.companyName = results[0].companyName;
        }
      }));
    }
    this.bindDataSource([]);
    this.subscription.push(this.sliderModelService.modelData.subscribe(x => {
      if (x.AccountName) {
        this.requestObject = x;
        this.selectedAccount = x.AccountName;
        this.accountNumber = x.AccountNumber;
        this.getProductAvailability();
      }
    }));
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Table
    this.setItemAvailTableHeight();
  }

  // Set Dynamic Height of the Product availability table
  setItemAvailTableHeight() {
    const productTableHeight = window.innerHeight - $('.reportHeaderTopSec').outerHeight() - $('.tableTotalsSec').outerHeight();
    $('.productAvailTable').css('height', productTableHeight + 'px');
  }
  public bindDataSource(data: any[]) {
    this.productAvailabilityListDS = new MatTableDataSource(data);
    this.productAvailabilityListDS.paginator = this.productPaginator;
    this.productAvailabilityListDS.sort = this.itemSort;
  }

  public getProductAvailability() {
    this.itemList = [];
    this.selectedProductList.forEach(x => {
      this.itemList.push(x.itemNumber);
    });

    const data = this.requestObject;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.reportService.getProductsAvailability(data).subscribe((results: any[]) => {
      if (results) {
        this.productAvailabilityList = results;
        if (this.productAvailabilityList && this.productAvailabilityList.length > 0) {
          this.curentDateTime = new Date();
          this.bindDataSource(this.productAvailabilityList);
        }
        this.loaderService.setLoaderStatus(false);
      }
      else {
        this.productAvailabilityList = [];
        this.bindDataSource(this.productAvailabilityList);
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // filter the dealer order lines on the basis of "Dislpay Non-Zero Lines only" checkbox
  public filterNonZeroAvailabilityDetail(getZeroQtyRecordsChecked: boolean) {
    this.ignoreZeroQtyRecords = getZeroQtyRecordsChecked;

    if (this.ignoreZeroQtyRecords) {
      this.paList = this.productAvailabilityList.filter(a => a.seedAvailability > 0);
    } else {
      this.paList = this.productAvailabilityList;
    }
    this.bindDataSource(this.paList);
  }

  public export() {
    const exportData = [];
    if (this.productAvailabilityListDS && this.productAvailabilityListDS.data.length > 0) {
      this.loaderService.setLoaderStatus(true);

      if (this.ignoreZeroQtyRecords) {
        this.paList = this.productAvailabilityList.filter(a => a.seedAvailability > 0);
      } else {
        this.paList = this.productAvailabilityList;
      }

      this.paList.forEach(x => {
        exportData.push({
          'Product Name': x.brand + ' - ' + x.marketingBrand + ' - ' + x.itemDescription,
          'SeedAvailability': x.seedAvailability ? x.seedAvailability : 0,
          'Maturity': x.maturity,
          'Seed Size': x.seedSize,
          'Package Size': x.packageSize,
          'Treatment': x.treatment,
          'Technology': x.technology,
          'Marketing Brand': x.marketingBrand,
          'Product Line': x.productLine
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'ProductAvailabilityReport');
      this.loaderService.setLoaderStatus(false);
    }
  }

  public onCancel() {
    this.bindDataSource([]);
    this.sliderModelService.close();
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
